<template>
    <rkm-area
        title="Mensagem Protocolo"
        type="fieldset"
    >

        <Form :data="data" />
    </rkm-area>
</template>

<script>

// Components.
import Form from './Form'

export default {
    components: { Form },
    props: {
        data: { type: Object, required: true },
    },
}
</script>